import * as React from "react";
import { AdUnitFormat, AppState } from "@store";
import { AdFormatDetails } from "./AdFormatDetails";
import { ChartPlaceholder } from "@pages";
import { connect } from "react-redux";
import { FetchingState } from "rd-redux-http";
import { ChartDataResponse, MetricInfo, AdInteractionMetrics } from "@api/common";

export interface AdFormatDetailsListComponentProps {
    adFormats: AdUnitFormat[];
    data: ChartDataResponse;
    adTypeDetailsMetrics: MetricInfo[];
}

export function AdFormatDetailsListComponent({
    adFormats,
    adTypeDetailsMetrics,
    data
}: AdFormatDetailsListComponentProps) {
    return (
        <>
            {adFormats.map(adu => (
                <ChartPlaceholder size="full" key={adu.size}>
                    <AdFormatDetails adFormat={adu} adTypeDetailsMetrics={adTypeDetailsMetrics} data={data} />
                </ChartPlaceholder>
            ))}
        </>
    );
}

export const AdFormatDetailsList = connect(
    (appState: AppState): AdFormatDetailsListComponentProps => {
        const allAdFormats = FetchingState.getDataOrDefault(appState.mappings.adunits, []);
        const data: ChartDataResponse = FetchingState.getDataOrDefault(appState.reports.chartData.adInteractionData, {
            metrics: [],
            dimensions: []
        });

        const adFormats = allAdFormats
            .map(adf => ({
                ...adf,
                types: adf.types.filter(adt =>
                    data.metrics.some(m =>
                        m.data.some(
                            d =>
                                d["dimension-values"].indexOf(adf.size) !== -1 &&
                                d["dimension-values"].indexOf(adt.interaction.name) !== -1
                        )
                    )
                )
            }))
            .filter(adf => !!adf.types.length);

        return {
            adFormats,
            data,
            adTypeDetailsMetrics: AdInteractionMetrics
        };
    }
)(AdFormatDetailsListComponent);
